import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._onKeydown = this._handleKeydown.bind(this)
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  _handleKeydown(event) {
    const tag = event.target.tagName
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || event.target.isContentEditable) return
    if (event.ctrlKey || event.metaKey || event.altKey) return

    switch (event.key) {
      case "g":
        event.preventDefault()
        this._waitForSecondKey(event)
        break
      case "/":
        event.preventDefault()
        this._focusSearch()
        break
      case "?":
        event.preventDefault()
        this._toggleHelp()
        break
    }
  }

  _waitForSecondKey() {
    const handler = (e) => {
      document.removeEventListener("keydown", handler)
      clearTimeout(timer)

      const tag = e.target.tagName
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return

      switch (e.key) {
        case "d": e.preventDefault(); Turbo.visit("/"); break
        case "q": e.preventDefault(); Turbo.visit("/quotes"); break
        case "p": e.preventDefault(); Turbo.visit("/projects"); break
        case "c": e.preventDefault(); Turbo.visit("/clients"); break
        case "s": e.preventDefault(); Turbo.visit("/suppliers"); break
      }
    }

    const timer = setTimeout(() => {
      document.removeEventListener("keydown", handler)
    }, 1000)

    document.addEventListener("keydown", handler)
  }

  _focusSearch() {
    const searchInput = document.querySelector("[data-filter-target='search']") ||
                        document.querySelector("input[type='search']") ||
                        document.querySelector("input[placeholder*='erca']")
    if (searchInput) {
      searchInput.focus()
      searchInput.select()
    }
  }

  _toggleHelp() {
    const dialog = document.getElementById("hotkey-help")
    if (!dialog) return
    dialog.open ? dialog.close() : dialog.showModal()
  }

  openPalette(event) {
    event?.preventDefault()
    window.dispatchEvent(new CustomEvent("command-palette:open"))
  }
}
